import "./SignInPageStyles.scss";
import { FC, useContext, useState } from "react";
import Layout from "../../../layout/Layout";
import { useForm } from "react-hook-form";
import Validators from "../../../../utils/Validators";
import { ErrorMessage } from "@hookform/error-message";
import { Link, useNavigate } from "react-router-dom";
import Icons from "../../../assets/Icons";
import AuthGateModal from "../../../components/authGateModal/AuthGateModal";
import { GoogleAuthButton } from "../../../components/googleAuthButton";
import { loginConCorreo } from "../../../components/authGateModal/loginConCorreo";
import { trackEvent } from "../../../../../lib/analytics";
import { routes } from "../../../routes/RoutesComponent";
import ModalsContext from "../../../../../domain/providers/modal/ModalsContext";
import ModalsContextType from "../../../../../domain/providers/modal/ModalsContextType";
import { Helmet } from "react-helmet-async";
import UserContext from "../../../../../domain/providers/user/UserContext";
import { useTrackOnce } from "../../../hooks/useTrackOnce";

const SignInPage: FC<{}> = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
    } = useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [verClave, setVerClave] = useState(false);
    const [modalVista, setModalVista] = useState<"registro" | "olvide" | undefined>(undefined);

    const { addToast } = useContext(ModalsContext) as ModalsContextType;
    const { setUser } = useContext(UserContext);

    useTrackOnce("pagina_vista", { pagina: "iniciar_sesion" });

    const _handleSubmit = async (data: any) => {
        setLoading(true);
        try {
            setUser(await loginConCorreo(data.email, data.password));
            trackEvent("sesion_iniciada", { metodo: "email" });
            navigate(routes.home.relativePath);
        } catch (e: any) {
            const motivo = e?.error ?? e?.message ?? e?.detail ?? "Credenciales erradas";
            trackEvent("sesion_inicio_fallido", { metodo: "email", motivo_error: motivo });
            addToast(motivo, "error", undefined);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="sign_in_page">
            <Layout>
                <Helmet>
                    <title>Inicie sesión - wcar</title>
                </Helmet>
                <div className="container py-4">
                    <div className="row d-flex flex-md-row-reverse">
                        <div className="col-md-6 px-0 px-md-3 mb-4">
                            <img
                                src="/assets/pages/signIn/bg_sign_in.jpeg"
                                className="img-fluid h-100 object_cover"
                                alt="Inicie sesión"
                                title="Inicie sesión"
                            />
                        </div>
                        <div className="col-md-1"></div>
                        <div className="col-md-4 content_page">
                            <h2 className="text_bold mb-3 mt-6">Inicie sesión</h2>
                            <p className="mb-4 mst-4">
                                Por favor, inicie sesión con su correo electrónico y contraseña.
                            </p>
                            <form onSubmit={handleSubmit(_handleSubmit)}>
                                <div className="form-group my-3">
                                    <label className="mandatory">Email</label>
                                    <input
                                        type="email"
                                        placeholder="ejemplo@gmail.com"
                                        className="form-control"
                                        {...register(
                                            "email",
                                            Validators({
                                                email: true,
                                                required: true,
                                            }),
                                        )}
                                    />
                                    <ErrorMessage as="aside" errors={errors} name="email" />
                                </div>

                                <div className="form-group my-3">
                                    <label className="mandatory">Contraseña</label>
                                    <div style={{ position: "relative" }}>
                                        <input
                                            type={verClave ? "text" : "password"}
                                            className="form-control"
                                            style={{ paddingRight: 76 }}
                                            {...register("password", Validators({ required: true }))}
                                        />
                                        <button
                                            type="button"
                                            aria-label={verClave ? "Ocultar contraseña" : "Mostrar contraseña"}
                                            onClick={() => setVerClave((v) => !v)}
                                            style={{
                                                position: "absolute",
                                                right: 12,
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                border: 0,
                                                background: "none",
                                                padding: 0,
                                                color: "#ff6600",
                                                fontSize: "0.8rem",
                                                fontWeight: 600,
                                            }}
                                        >
                                            {verClave ? "Ocultar" : "Mostrar"}
                                        </button>
                                    </div>
                                    <ErrorMessage as="aside" errors={errors} name="password" />
                                </div>

                                <button
                                    type="button"
                                    style={{
                                        border: 0,
                                        background: "none",
                                        padding: 0,
                                        borderRadius: 0,
                                        color: "#ff6600",
                                        fontWeight: 600,
                                        fontSize: "0.875rem",
                                    }}
                                    onClick={() => setModalVista("olvide")}
                                >
                                    ¿Olvidaste tu contraseña?
                                </button>

                                <div className="w-100 d-flex justify-content-center mt-5">
                                    <button className="btn btn_orange" type="submit" disabled={loading}>
                                        INICIAR SESIÓN
                                        <Icons.PersonRounded />
                                    </button>
                                </div>
                            </form>
                            <p className="text-center mt-4 mb-0">
                                ¿No tienes cuenta?{" "}
                                <button
                                    type="button"
                                    style={{
                                        border: 0,
                                        background: "none",
                                        padding: 0,
                                        borderRadius: 0,
                                        color: "#ff6600",
                                        fontWeight: 600,
                                    }}
                                    onClick={() => setModalVista("registro")}
                                >
                                    Regístrate
                                </button>
                            </p>
                            <div className="mt-4">
                                <GoogleAuthButton largo />
                            </div>
                        </div>
                        <div className="col-md-1"></div>
                    </div>
                </div>
                {modalVista && (
                    <AuthGateModal
                        vistaInicial={modalVista}
                        onClose={() => setModalVista(undefined)}
                        onSuccess={() => navigate(routes.home.relativePath)}
                    />
                )}
            </Layout>
        </div>
    );
};

export default SignInPage;
